import React from 'react';
import styled from 'styled-components';
import Modal from "../../shared/Modal";
import DepositSection from "./DepositSection";
import colors from "../../styles/colors";


const CustomDepositSection = styled(DepositSection)`
  padding: 30px;
  background: ${colors.white};
  border-radius: 10px;
`;

const CustomModal = styled(Modal)`
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${CustomDepositSection} {
    width: 100%;
    max-width: 610px;
  }
`;


class DepositModal extends React.Component {
  componentDidMount() {
    window.analytics.track("Shift - Deposit Modal Opened");
  }

  render() {
    const {phone, onComplete, ...props} = this.props;

    return (
      <CustomModal {...props}>
        <CustomDepositSection phone={phone} onComplete={onComplete}/>
      </CustomModal>
    )
  }
}


export default DepositModal;


// WEBPACK FOOTER //
// ./src/pages/shift-page/DepositModal.js